export default "__VITE_ASSET__3809e40a__"